import {setMessage, isVisible} from './message'
import {megaDispatch} from './megaDispatch'

export const addReportType = (url, postData) => {
    let data = new FormData;
    
    data.append('name', postData.reportData.name );
    data.append('file_type', postData.selectedFileType);
    data.append('selectedAddresses', postData.selectedAddresses);
    data.append('is_active', postData.reportData.is_active ? '1' : '0');
    data.append('is_global', postData.reportData.is_global ? '1' : '0');

    if(postData.id) {
        data.append('id', postData.id);
    }
    
    return (dispatch) => {
        fetch(url + '/api/report/action/addReport',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {  
                data = JSON.parse(data);     
                dispatch(setMessage({type: data.type, message: data.message}));

                if(data.type == 'success') {
                    if(postData.id) {
                        dispatch(updateReportType(data.dbRecord, postData.index));
                    }else{
                        dispatch(addNewReportType(data.dbRecord));
                    }
                }
            })
            .catch((error) => {
                
                
            });
    };
}


export const addGlobalReportType = (url, postData) => {
    let data = new FormData;
    
    data.append('name', postData.reportData.name );
    data.append('selectedCategories', postData.selectedMetaCategories);
    data.append('is_global', '1');
    data.append('is_active', postData.reportData.is_active ? '1' : '0');

    if(postData.id) {
        data.append('id', postData.id);
    }
    
    return (dispatch) => {
        fetch(url + '/api/report/action/addGlobalReport',
        {
            method: "POST",
            body: data
        })
            .then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }

                return response;
            })
            .then((response) => response.json())
            .then((data) => {  
                data = JSON.parse(data);     
                dispatch(setMessage({type: data.type, message: data.message}));

                if(data.type == 'success') {
                    if(postData.id) {
                        dispatch(updateReportType(data.dbRecord, postData.index));
                    }else{
                        dispatch(addNewReportType(data.dbRecord));
                    }
                }
            })
            .catch((error) => {
                
                
            });
    };
}

export const setReportTypeData = data => {
    return {
        type: 'REPORT_DATA',
        payload: data
    }
}

export const addNewReportType = data => {
    return {
        type : 'ADD_NEW_REPORT',
        payload: data
    }
}

export const updateReportType = (data, index) => {
    const updatedData = {
        data,
        index
    }
    return {
        type : 'UPDATE_REPORT',
        payload: updatedData
    }
}

export const getAllReportTypes = (url) => {
    return (dispatch) => {
        fetch(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }

            return response;
        })
        .then((response) => response.json())
        .then((data) => {
            //-- set clients data
           
            dispatch(setReportTypeData(data))

        })
        .catch(() => dispatch(setMessage({type: 'danger', message: 'Kan adres data niet ophalen'})));
    };
}


// WEBPACK FOOTER //
// ./src/actions/report.js